// CNY Suggested Order ShipTo Address Actions
// This handles the shipTo address separately from cart API

export const cnyShipToAddressActionTypes = {
  SET_CNY_SHIPTO_ADDRESS: "SET_CNY_SHIPTO_ADDRESS",
  CLEAR_CNY_SHIPTO_ADDRESS: "CLEAR_CNY_SHIPTO_ADDRESS",
};

// Set CNY shipTo address when order is selected
export const setCNYShipToAddressAction = (shipToAddress) => {
  // Also store in localStorage for persistence
  if (shipToAddress) {
    try {
      localStorage.setItem("cnyShipToAddress", JSON.stringify(shipToAddress));
    } catch (error) {
      console.error("Error storing CNY address in localStorage:", error);
    }
  }
  
  return {
    type: cnyShipToAddressActionTypes.SET_CNY_SHIPTO_ADDRESS,
    payload: shipToAddress,
  };
};

// Clear CNY shipTo address
export const clearCNYShipToAddressAction = () => {
  // Clear from localStorage
  localStorage.removeItem("cnyShipToAddress");
  
  return {
    type: cnyShipToAddressActionTypes.CLEAR_CNY_SHIPTO_ADDRESS,
  };
};
